import styled, { css, keyframes } from 'styled-components'
import { colors } from '../../../styles/GlobalVariables'

interface RailItemDetailsProps {
  height?: 'true' | 'false'
}

const loader = keyframes`
  0% {
    background-color: black;
  }
  100% {
    background-color: ${colors.tvGuideDark};
  }
`

export const RailItemWrap = styled.div`
  overflow: visible;
  cursor: pointer;
  display: flex;
  flex-direction: column;
  color: white;

  &.first {
    transform-origin: right;
  }

  &.last {
    transform-origin: left;
  }
`

export const RailItemImageWrap = styled.div`
  border-radius: 10px;
  display: inline-block;
  height: 0;
  padding-bottom: calc(100% * 9 / 16);
  width: 100%;
  overflow: hidden;
  box-shadow: 0 9px 9px rgba(0, 0, 0, 0.4);
  position: relative;

  ${props =>
    props.theme.loaded
      ? ''
      : css`
          animation: ${loader} 1s linear infinite;
        `}
  &:after {
    content: '';
    transition: opacity 0.2s ease;
    opacity: 0;
    position: absolute;
    bottom: 0.625rem;
    right: 0.625rem;
    width: 1.25rem;
    height: 1.25rem;
    background-size: contain;
    background-repeat: no-repeat;
    background-image: url("data:image/svg+xml,%3C%3Fxml version='1.0' encoding='iso-8859-1'%3F%3E%3C!DOCTYPE svg PUBLIC '-//W3C//DTD SVG 1.1//EN' 'http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd'%3E%3Csvg fill='white' version='1.1' id='Capa_1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' width='2rem' height='2rem' viewBox='0 0 163.861 163.861' xml:space='preserve'%3E%3Cg%3E%3Cpath d='M34.857,3.613C20.084-4.861,8.107,2.081,8.107,19.106v125.637c0,17.042,11.977,23.975,26.75,15.509L144.67,97.275 c14.778-8.477,14.778-22.211,0-30.686L34.857,3.613z'/%3E%3C/g%3E%3C/svg%3E");
    z-index: 1;
  }
  transition: transform 0.5s ease;
  &:hover {
    opacity: 1;
    transform: scale(1.05);
    &:after {
      opacity: 1;
    }
  }

  ${props =>
    !props.theme.found
      ? css`
          background: linear-gradient(
            90deg,
            #06060d -34.07%,
            #171f3d 47.01%,
            #06060d 137.67%
          );

          img {
            width: 45%;
          }
        `
      : ''};
  @media only screen and (max-width: 768px) {
    &:hover {
      opacity: 1;
      transform: none;
    }

    &:after {
      display: none;
    }
  }
`

export const RailItemImage = styled.img`
  width: 100%;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);

  @media only screen and (max-width: 768px) {
    height: 100%;
  }
`
export const RailItemDetailsWrap = styled.div<RailItemDetailsProps>`
  position: absolute;
  bottom: -70px;
  //height: 85px;
  height: 55px;
  display: flex;
  justify-content: ${props =>
    props.theme.isCatchup ? 'flex-start' : 'space-between'};
  flex-direction: ${props =>
    props.theme.isCatchup ? ' column-reverse' : 'column'};

  @media only screen and (max-width: 768px) {
    position: relative;
    top: initial;
    bottom: -3.2vw;
    justify-content: flex-start;
    gap: 4px;
  }
`

export const RailItemTitle = styled.div`
  color: #fff;
  text-align: right;
  font-family: 'Narkiss Block RESHET', sans-serif;
  font-size: 22px;
  font-style: normal;
  font-weight: 300;
  letter-spacing: -0.54px;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;

  @media only screen and (max-width: 768px) {
    font-size: 18px;
  }
`
export const EmptyDescriptionContainer = styled.div`
  width: 320px;
  height: 66px;

  @media only screen and (max-width: 768px) {
    //font-size: 20px; /* Adjust font size for smaller screens */
  }
`

export const RailItemDate = styled.div`
  color: rgba(255, 255, 255, 0.5);
  text-align: right;
  font-family: 'Narkiss Block RESHET', sans-serif;
  font-size: 1.25rem;
  font-style: normal;
  font-weight: 100;
  line-height: normal;
  letter-spacing: -0.48px;

  @media only screen and (max-width: 768px) {
    font-size: 1.15rem;
  }
`
